import { AbstractControl, Validators } from '@angular/forms';
import { PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';
import { FormGroupValueOf } from '@utility/utility';
import {
    equalOrMoreThanTodayOnlyIfCRCDateValidator,
    maxLengthValidator,
    notWhitespaceValidator,
} from '@utility/utility.validators';
import { Moment } from 'moment';

export class LodgingRequestDetailsFormGroup extends PersistentFormGroup<{
    checkInDate: PersistentFormControl<Moment | null>;
    checkOutDate: PersistentFormControl<Moment | null>;
    specialRequests: PersistentFormControl<string | null>;
}> {
    public static create(value: FormGroupValueOf<LodgingRequestDetailsFormGroup>): LodgingRequestDetailsFormGroup {
        return new LodgingRequestDetailsFormGroup(
            {
                checkInDate: new PersistentFormControl(value.checkInDate, [
                    Validators.required,
                    equalOrMoreThanTodayOnlyIfCRCDateValidator,
                ]),
                checkOutDate: new PersistentFormControl(value.checkOutDate, [
                    Validators.required,
                    equalOrMoreThanTodayOnlyIfCRCDateValidator,
                ]),
                specialRequests: new PersistentFormControl(value.specialRequests, [
                    notWhitespaceValidator(),
                    maxLengthValidator(1000),
                ]),
            },
            [
                (control: AbstractControl<LodgingRequestDetailsFormGroup['value']>) => {
                    const value = control.value;
                    if (!value.checkInDate || !value.checkOutDate) return null;
                    return value.checkInDate <= value.checkOutDate
                        ? null
                        : {
                              invalidDates: 'Check-out date cannot be before check-in date.',
                          };
                },
            ]
        );
    }
}
